import { Typography } from "antd";
import { FunctionComponent } from "react";
const { Text } = Typography;

interface CopyRightProps {}

const CopyRight: FunctionComponent<CopyRightProps> = () => {
  return (
    <div className="copy-right">
      <Text>Copyright @ all right reserves</Text>;
    </div>
  );
};

export default CopyRight;
